import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { useGetRefinBannerStatus } from '@/query/queries/loan/useGetRefinBannerStatus';
import Icon from './assets/icon_duo.svg';
import IconClose from './assets/icon_xmark.svg';
import s from './index.module.scss';

export const RefinBanner = ({ onMore, className }) => {
  const { data: banner } = useGetRefinBannerStatus();
  const [show, setShow] = React.useState(true);
  const { t } = useTranslation('loans');

  if (!banner?.is_banner_visible || !show) return null;

  return (
    <div className={classnames(s.wrapper, className)}>
      <img src={Icon} alt="icon" width={32} height={32} className={s.icon} />
      <div className={s.content}>
        <div className="f-18 f-500">{t('refin_banner.title')}</div>
        <div className="f-14">{t('refin_banner.description')}</div>
        {onMore ? (
          <MyLink href={APP_LINKS.loanTermsRefinancing()} className={s.link}>
            {t('refin_banner.learn_more')}
          </MyLink>
        ) : (
          <MyLink href={APP_LINKS.loans} className={s.link}>
            {t('refin_banner.check_loans')}
          </MyLink>
        )}
      </div>
      <img
        onClick={() => setShow(false)}
        src={IconClose}
        alt="icon-close"
        width={20}
        height={20}
        className={s.close_btn}
      />
    </div>
  );
};
